import "./tailwind.css";

const netlifyIdentity = require("netlify-identity-widget");
netlifyIdentity.init({
  locale: "en", // defaults to 'en'
});
